<!-- MyComponent.vue -->

<template>
    <div>
        <div class="new-container-deals">
            <div class="ps-container pt-3">
                <div class="time-banner">
                    <img v-lazy-load data-src="https://s3.ap-south-1.amazonaws.com/happimobiles/retool-upload/a81b48c3-8e81-4655-8360-952d838f2e1a.jpg"
                        alt="mobile-time-banner" />
                    <div class="ab">
                        <ul>
                            <!-- <li>
                                <h6>{{ days }}</h6>
                                <p>DAYS</p>
                            </li> -->
                            <!-- <li>
                                <h6>:</h6>
                            </li> -->
                            <li>
                                <h6>{{ hours }}</h6>
                                <p>HOURS</p>
                            </li>
                            <li>
                                <h6>:</h6>
                            </li>
                            <li>
                                <h6>{{ minutes }}</h6>
                                <p>MINUTES</p>
                            </li>
                            <li>
                                <h6>:</h6>
                            </li>
                            <li>
                                <h6>{{ seconds }}</h6>
                                <p>SECONDS</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            days: "00",
            hours: "00",
            minutes: "00",
            seconds: "00",
                  countdownInterval: null,
                        targetDate: new Date("2024-01-17T23:30:00").getTime(),
      remainingTime: 0,


        };
    },
    methods:  {
    updateCountdown() {
      // Current date/time
      const currentDate = new Date().getTime();

      // Calculate the remaining time in milliseconds
      this.remainingTime = this.targetDate - currentDate;

      // Check if the countdown is over
      if (this.remainingTime <= 0) {
        clearInterval(this.countdownInterval);
      } else {
        // Calculate days, hours, minutes, and seconds
        this.days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);
        
      }
      if (this.days.length == 1) this.days = "0" + this.days;
                if (this.hours.length == 1) this.hours = "0" + this.hours;
                if (this.minutes.length == 1) this.minutes = "0" + this.minutes;
                if (this.seconds.length == 1) this.seconds = "0" + this.seconds;

    },
  },
  beforeDestroy() {
    clearInterval(this.countdownInterval);
  },

    mounted()  {
    this.updateCountdown();
    // Update the countdown every second
    this.countdownInterval = setInterval(this.updateCountdown, 1000);
  },

};
</script>

   
<style scoped>
.time-banner img {
    width: 100%;
}

.time-banner {
    position: relative;
}

.ab {
    position: absolute;
    top: 14%;
    left: auto;
    right: 21%;
    bottom: auto;
    color: white;
}

ul {
    display: flex;
    list-style: none;
    gap: 18px;
}

li {
    font-size: 40px;
    font-weight: bold;
}

li p {
    color: white;
    text-align: center;
    font-size: 12px;
}

h6 {
    color: white;
    margin-bottom: 0;
    font-size: 40px;
    font-weight: bold;
}
</style>
  